export default __webpack_public_path__ + "static/media/Z.14360069.svg";